// extracted by mini-css-extract-plugin
export default {"registry":"Registry_registry__P3-H7","indicator":"Registry_indicator__KUkwf","inRegistry":"Registry_inRegistry__NHOP0"};